import React, { useEffect, useState } from "react";
import { GetMonthNameByNumber } from "../../../Helper/GetMonthNameByNumber";
import { FormatMoney } from "../../../../../Helpers/FormatNumber";
import { Agrupar, TotalizarByProp } from "../Agrupar";

export const Sucursal = ({ data, ejercicio, mes }) => {
  const [state, setState] = useState({
    data: [],
    conceptos: [],
    adr: [],
  });
  const [totales, setTotales] = useState([]);
  useEffect(() => {
    var array = Agrupar(data, "sucursal");
    setState({
      adr: array,
      conceptos: Agrupar(data, "concepto"),
    });
    var arrayTotales = [];
    array.map((item) => {
      arrayTotales = [
        ...arrayTotales,
        {
          invactual: TotalizarByProp(data, "sucursal", item, "invactual"),
          invanterior: TotalizarByProp(data, "sucursal", item, "invanterior"),
          dias: TotalizarByProp(data, "sucursal", item, "dias"),
          diasant: TotalizarByProp(data, "sucursal", item, "diasant"),
        },
      ];
    });

    setTotales(arrayTotales);
  }, [data]);
  const handleObj = (concepto, adr) => {
    var obj = {
      invactual: 0,
      invanterior: 0,
      dias: 0,
      diasant: 0,
    };

    data.forEach((item) => {
      if (item.concepto === concepto && item.sucursal === adr) {
        obj.invactual += item.invactual;
        obj.invanterior += item.invanterior;
        obj.dias += item.dias;
        obj.diasant += item.diasant;
      }
    });
    // const result = [obj]
    return [obj];
  };
  return (
    <div id="container-inventario-detallado">
      <table id="inventario-detallado" cellSpacing={0}>
        <thead>
          <tr>
            {/* <th rowSpan={2}>Linea</th> */}
            <th className="sticky-enc-200"></th>
            {state.adr.map((item) => (
              <th colSpan={5}>{item}</th>
            ))}
          </tr>
          <tr>
            <th className="sticky-enc-200" rowSpan={2}>
              Linea
            </th>
            {state.adr.map((item) => (
              <>
                <th>
                  {GetMonthNameByNumber(mes)} - {ejercicio}
                </th>
                <th>Días</th>
                <th>
                  {GetMonthNameByNumber(mes)} - {ejercicio - 1}
                </th>
                <th>Días</th>
                <th rowSpan={2}>Diferencia </th>
              </>
            ))}
          </tr>
        </thead>
        <tbody>
          {state.conceptos.map((concepto) => (
            <tr>
              <td className="sticky-col-200">{concepto}</td>
              {state.adr.map((item) =>
                handleObj(concepto, item).map((x) => (
                  <>
                    <td>{FormatMoney(x.invactual, 0)}</td>
                    <td  style={{textAlign:'center'}}>{x.dias}</td>
                    <td>{FormatMoney(x.invanterior, 0)}</td>
                    <td  style={{textAlign:'center'}}>{x.diasant}</td>
                    <td  style={{textAlign:'center'}}>
                      {FormatMoney((x.invactual / x.invanterior - 1) * 100, 0)}{" "}
                      %
                    </td>
                  </>
                ))
              )}
            </tr>
          ))}
          <tr className="totales">
            <td className="sticky-col-200">TOTAL</td>
            {totales.map((item) => (
              <>
                <td>{FormatMoney(item.invactual, 0)}</td>
                <td></td>
                {/* <td  style={{textAlign:'center'}}>{FormatMoney(item.diasant, 0)}</td> */}
                <td>{FormatMoney(item.invanterior, 0)}</td>
                <td></td>
                {/* <td  style={{textAlign:'center'}}>{FormatMoney(item.diasant, 0)}</td> */}
                <td  style={{textAlign:'center'}}>
                  {FormatMoney(
                    (item.invactual / item.invanterior - 1) * 100,
                    0
                  )}{" "}
                  %
                </td>
              </>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
};
